import Temporal from "@/shared/ts/temporal";
import Lifestyle from "./lifestyle";

class IncomeCalculator {
  private baseIncomeAmounts = {};
  public baseDate = new Date(2025, 0, 1, 0, 0, 0, 0);

  constructor() {
    this.configureBaseIncomeAmounts();
  }

  public getBaseAmount(
    livesInLondon: boolean,
    supportingPartner: boolean,
    lifestyle: Lifestyle
  ) {
    const key = this.getKey(livesInLondon, supportingPartner, lifestyle);
    return this.baseIncomeAmounts[key];
  }

  public calcSuggestedRetirementIncome(
    livesInLondon: boolean,
    supportingPartner: boolean,
    lifestyle: Lifestyle,
    targetRetirementDate: Date
  ): number {
    const baseAmount = this.getBaseAmount(
      livesInLondon,
      supportingPartner,
      lifestyle
    );
    const adjustedAmount =
      Math.round(this.applyInflation(baseAmount, targetRetirementDate) / 100) *
      100;
    return adjustedAmount;
  }

  private applyInflation(value: number, targetRetirementDate: Date): number {
    const yearTillRetirement = Temporal.yearsBetweenDates(
      this.baseDate,
      targetRetirementDate
    );
    const inflationRate = 2.5;
    const inflationIncreaseRate = 1 + inflationRate / 100;
    return value * Math.pow(inflationIncreaseRate, yearTillRetirement);
  }

  private getKey(
    livesInLondon: boolean,
    supportingPartner: boolean,
    lifestyle: Lifestyle
  ): string {
    const getKeyFromBoolean = (boolValue: boolean): string =>
      boolValue ? "Y" : "N";
    const livesInLondonKey = getKeyFromBoolean(livesInLondon);
    const supportingPartnerKey = getKeyFromBoolean(supportingPartner);
    let lifestyleKey = "";
    switch (lifestyle) {
      case Lifestyle.Minimum:
        lifestyleKey = "MI";
        break;
      case Lifestyle.Living:
        lifestyleKey = "LI";
        break;
      case Lifestyle.Moderate:
        lifestyleKey = "MO";
        break;
      case Lifestyle.Comfortable:
        lifestyleKey = "CO";
        break;
    }
    return `${livesInLondonKey}${supportingPartnerKey}${lifestyleKey}`;
  }

  private configureBaseIncomeAmounts() {
    this.baseIncomeAmounts["NNMI"] = 13900;
    this.baseIncomeAmounts["NNLI"] = 26200;
    this.baseIncomeAmounts["NNMO"] = 32700;
    this.baseIncomeAmounts["NNCO"] = 45400;

    this.baseIncomeAmounts["YNMI"] = 14600;
    this.baseIncomeAmounts["YNLI"] = 28900;
    this.baseIncomeAmounts["YNMO"] = 34000;
    this.baseIncomeAmounts["YNCO"] = 47200;

    this.baseIncomeAmounts["NYMI"] = 0;
    this.baseIncomeAmounts["NYMO"] = 0;
    this.baseIncomeAmounts["NYCO"] = 0;
    this.baseIncomeAmounts["YYMI"] = 0;
    this.baseIncomeAmounts["YYMO"] = 0;
    this.baseIncomeAmounts["YYCO"] = 0;
  }
}

export default IncomeCalculator;
